import React, { useState, useContext } from 'react'
import { AuthContext } from '../../context/authContext.js'
import { Link, useNavigate } from 'react-router-dom'
import { IoPerson } from "react-icons/io5"
import { RiLogoutBoxLine } from "react-icons/ri"
import { logoutUser } from '../../Functions/API/services/authService.js'

const ProfileShortcut = ({menuOpen, setConnectionStatus,setMenuOpen }) => {
  const navigate = useNavigate()
  const { user, logout } = useContext(AuthContext)
  const [showDropdown, setShowDropdown] = useState(false)

  return (
    <div className='ProfileShortcut' >
      {/* Desktop: show username + role, Mobile: icon only */}
      {menuOpen?(<Link to='/Profile' className='ProfileLink'><div className='ProfileName' onClick={()=>setMenuOpen(false)}>
        <h1>{user.username}</h1>
        <h2>{user.role}</h2>
      </div>
      <span className="arrow">▾</span></Link>) :(
        <div className='Desktop-ProfileShortcut' onClick={() => {setShowDropdown(!showDropdown)}}>
       <div className='ProfileName'>
        <h1>{user.username}</h1>
        <h2>{user.role}</h2>
      </div>
      <span className="arrow">▾</span>
      </div>)
       
}



      {(showDropdown || menuOpen) && (
        <ul className={menuOpen?"Logout-Responsive":"dropdown"}>
          <li className='ProfileShortCut' onClick={() => {setShowDropdown(false)/* ; setMenuOpen(false) */}}>
            <IoPerson />
            <Link to='/Profile'>See Profile</Link>
          </li>
          <li onClick={async () => {
            navigate('/')
            setShowDropdown(false)
            setMenuOpen(false)
            setConnectionStatus(false)
            await logoutUser()
            await logout()
          }} className='LogoutButton'>
            <RiLogoutBoxLine style={{ color: 'red' }} />
            <p style={{ color: 'red' }}>Log Out</p>
          </li>
        </ul>
      )}
    </div>
  )
}

export default ProfileShortcut
